import { render, staticRenderFns } from "./DatosForm.vue?vue&type=template&id=c7f5d468"
import script from "./DatosForm.vue?vue&type=script&lang=js"
export * from "./DatosForm.vue?vue&type=script&lang=js"
import style0 from "./DatosForm.vue?vue&type=style&index=0&id=c7f5d468&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports